module.exports = __webpack_public_path__ + "img/newpagebg5.4698012a.jpg";